module.exports = __webpack_public_path__ + "img/home_web_07.29cdf8d0.png";